<template>
  <ProductPageLayout
    name="芊荨视频转GIF制作"
    :logo="logo"
    :hero-image="heroImage"
    lead="本地转换，不上传。视频导入、屏幕录制与 GIF 工具箱共用同一编辑台，裁时间轴、控体积，把画面做成会动的瞬间。"
    :feature-lines="featureLines"
    download-link="/ftp/packages/gifmaker/GifMakerSetup.exe"
    download-file-name="GifMakerSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="从视频导入到 GIF 导出，编辑台与工具箱覆盖动图制作全流程。"
    other-desc="压缩、倒放、多图合成与格式转换，常用动图处理一站完成。"
    reviews-desc="真实反馈持续驱动 GIF 制作体验优化。"
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'GifMaker',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/gifmaker/logo_48x48.png'),
      heroImage: require('@/assets/gifmaker/首页.png'),
      featureLines: [
        '视频转 GIF / 屏幕录制 / 编辑台裁切 / 三档品质预设',
        'GIF 压缩 / 倒放 / 多图合成 / 格式转换 / 历史记录'
      ],
      metaItems: [
        { icon: 'video', label: '视频转 GIF' },
        { icon: 'lock', label: '本地不上传' },
        { icon: 'ad-free', label: '默认无水印' }
      ],
      detailedFeatures: [
        {
          title: '视频转 GIF',
          brief: '导入 mp4 / mov / mkv 等常见视频，时间轴裁切后一键导出。',
          detail: '支持多文件导入与批量转换，编辑台可精确选取片段、预览帧内容，并提供三档品质预设，在体积与清晰度之间灵活平衡。',
          image: require('@/assets/gifmaker/编辑台.png')
        },
        {
          title: '屏幕录制',
          brief: '框选区域或全屏录制，热键启停，录完直接进入编辑台。',
          detail: '适合教程演示、操作回放与社媒素材采集，录制完成后无需另开软件，可在同一编辑台裁剪时长并导出 GIF。',
          image: require('@/assets/gifmaker/屏幕录制.png')
        },
        {
          title: 'GIF 工具箱',
          brief: '压缩、倒放、多图合成与格式转换，常用动图处理集中完成。',
          detail: '内置 GIF 压缩、倒放、逐帧编辑、多图序列合成，以及 GIF / WebP / APNG 格式互转，无需在多款工具间来回切换。',
          image: require('@/assets/gifmaker/工具.png')
        },
        {
          title: '历史记录',
          brief: '最近转换与录制自动归档，随时回溯重新导出。',
          detail: '保留最近 100 条转换、录制与工具操作记录，可快速打开源文件路径、再次编辑或分享已导出的 GIF。',
          image: require('@/assets/gifmaker/历史.png')
        }
      ],
      otherFeatures: [
        { title: 'GIF 压缩', description: '在可接受画质下显著减小体积，更适合微信与文档嵌入。', icon: 'image' },
        { title: '逐帧编辑', description: '导入 GIF 后可删帧、调序，再导出新的动图。', icon: 'puzzle' },
        { title: '多图合成', description: '按序列将多张图片合成为 GIF，适合表情包与简单动画。', icon: 'sparkle' },
        { title: '本地处理', description: '转换与录制均在本地完成，默认导出无水印。', icon: 'lock' }
      ],
      reviews: [
        { name: '陈运营', comment: '把产品演示录屏裁成 GIF 发群里，编辑台裁时间轴很顺手，体积也比以前小很多。', avatar: require('@/assets/gifmaker/avatar1.jpg') },
        { name: '李设计', comment: 'UI 动效导出 GIF 终于不用开好几个软件了，压缩和倒放都在工具箱里，效率提升明显。', avatar: require('@/assets/gifmaker/avatar2.jpg') },
        { name: '王开发', comment: '录 Bug 复现步骤后直接转 GIF 贴到工单里，热键启停录制很稳定。', avatar: require('@/assets/gifmaker/avatar3.jpg') },
        { name: '张编辑', comment: '批量导入短视频转 GIF，三档品质预设够用，历史记录找之前的文件也方便。', avatar: require('@/assets/gifmaker/avatar4.jpeg') },
        { name: '赵老师', comment: '做课件把操作步骤录成 GIF，学生看步骤比静态截图清楚多了。', avatar: require('@/assets/gifmaker/avatar5.jpeg') },
        { name: '周同学', comment: '多图合成做表情包很快，本地处理不上传，用着放心。', avatar: require('@/assets/gifmaker/avatar6.jpeg') }
      ]
    }
  }
}
</script>
